/**
 * Logo-version groups for the PDP logo-version selector.
 *
 * One object per COLOUR of a garment - every colour is its own Shopify product - holding the
 * handle of each branding version that exists for it. A key is omitted, never blank, when that
 * version does not exist, and the versions are the six columns of the handle spreadsheet:
 * plain, white, grey, reflective, embroidered, updated. A group with fewer than two handles is
 * dropped rather than rendering a selector with nothing to select.
 *
 * Two sources. Most groups are derived from the handle markers in a catalogue export. The
 * UnifiedMove groups are stated outright by the spreadsheet, because their handles cannot be
 * paired by marker alone - High Waisted Shorts 6" Black is plain
 * 'unifiedmove-high-waisted-shorts-black' but white
 * 'unifiedmove-high-waisted-shorts-white-logo-6-black'. Where the sheet speaks it wins.
 *
 * The role is carried by the KEY, so it never has to be inferred from a title marker or from
 * created_at, and the versions cannot disagree - the handle -> { group, role } index is built
 * once in oa-logo-versions-api.js rather than being entered once per direction here.
 *
 * List every colour, not just the garment. Where this file answers for a handle it also decides
 * which sibling products belong to that version's colour family, so an unmapped colour of a
 * mapped garment is dropped from the colour selector by siblingColours.
 *
 * What it does NOT override: a product that is preview-launch or coming-soon is still never
 * offered. Listing a group says these are the same garment, not that any of them is sellable.
 *
 * GENERATED by scripts/build-logo-versions-map.py from a catalogue CSV export. Do not hand-edit.
 */
window.OA_LOGO_VERSION_GROUPS = [
  {
    plain: 'airmove-jacket-coal',
    reflective: 'airmove-jacket-with-reflective-logo-coal'
  },

  {
    reflective: 'airmove-jacket-with-bonding-with-reflective-logo-black',
    updated: 'airmove-jacket-with-bonding-new-branding-black'
  },
  {
    reflective: 'airmove-jacket-with-bonding-with-reflective-logo-true-blue',
    updated: 'airmove-jacket-with-bonding-new-branding-true-blue'
  },
  {
    reflective: 'airmove-jacket-with-bonding-with-reflective-logo-white',
    updated: 'airmove-jacket-with-bonding-new-branding-white'
  },

  {
    plain: 'airmove-lined-shorts-2-coal',
    reflective: 'airmove-lined-shorts-2-with-reflective-logo-coal'
  },

  {
    reflective: 'airmove-lined-shorts-2-with-pocket-and-reflective-logo-black',
    updated: 'airmove-lined-shorts-2-with-pocket-new-branding-black'
  },
  {
    reflective: 'airmove-lined-shorts-2-with-pocket-and-reflective-logo-true-blue',
    updated: 'airmove-lined-shorts-2-with-pocket-new-branding-true-blue'
  },
  {
    reflective: 'airmove-lined-shorts-2-with-pocket-and-reflective-logo-white',
    updated: 'airmove-lined-shorts-2-with-pocket-new-branding-white'
  },

  {
    plain: 'airmove-lined-shorts-3-coal',
    reflective: 'airmove-lined-shorts-3-with-reflective-logo-coal'
  },

  {
    reflective: 'airmove-lined-shorts-4-with-pocket-and-reflective-logo-black',
    updated: 'airmove-lined-shorts-4-with-pocket-new-branding-black'
  },
  {
    reflective: 'airmove-lined-shorts-4-with-pocket-and-reflective-logo-true-blue',
    updated: 'airmove-lined-shorts-4-with-pocket-new-branding-true-blue'
  },
  {
    reflective: 'airmove-lined-shorts-4-with-pocket-and-reflective-logo-white',
    updated: 'airmove-lined-shorts-4-with-pocket-new-branding-white'
  },

  {
    plain: 'airmove-pleated-skort-with-pockets-black',
    updated: 'airmove-pleated-skort-with-pockets-new-branding-black'
  },
  {
    plain: 'airmove-pleated-skort-with-pockets-white',
    updated: 'airmove-pleated-skort-with-pockets-new-branding-white'
  },

  {
    plain: 'airmove-skort-with-pockets-black',
    updated: 'airmove-skort-with-pockets-new-branding-black'
  },
  {
    plain: 'airmove-skort-with-pockets-white',
    updated: 'airmove-skort-with-pockets-new-branding-white'
  },

  {
    reflective: 'airmove-straight-leg-pants-with-reflective-logo-black',
    updated: 'airmove-straight-leg-pants-new-branding-black'
  },
  {
    reflective: 'airmove-straight-leg-pants-with-reflective-logo-true-blue',
    updated: 'airmove-straight-leg-pants-new-branding-true-blue'
  },
  {
    reflective: 'airmove-straight-leg-pants-with-reflective-logo-velvet-mocha',
    updated: 'airmove-straight-leg-pants-new-branding-velvet-mocha'
  },

  {
    plain: 'cotton-baby-t-shirt-with-printed-logo-light-grey-marl',
    grey: 'cotton-baby-t-shirt-with-grey-logo-light-grey-marl'
  },

  {
    plain: 'cotton-fitted-mid-vest-alpine-green',
    grey: 'cotton-fitted-mid-vest-with-grey-logo-alpine-green'
  },
  {
    plain: 'cotton-fitted-mid-vest-black',
    grey: 'cotton-fitted-mid-vest-with-grey-logo-black'
  },
  {
    plain: 'cotton-fitted-mid-vest-light-grey-marl',
    grey: 'cotton-fitted-mid-vest-with-grey-logo-light-grey-marl'
  },
  {
    plain: 'cotton-fitted-mid-vest-plum-brown',
    grey: 'cotton-fitted-mid-vest-with-grey-logo-plum-brown'
  },
  {
    plain: 'cotton-fitted-mid-vest-true-blue',
    grey: 'cotton-fitted-mid-vest-with-grey-logo-true-blue'
  },

  {
    plain: 'cotton-fitted-vest-alpine-green',
    grey: 'cotton-fitted-vest-with-grey-logo-alpine-green'
  },
  {
    plain: 'cotton-fitted-vest-black',
    grey: 'cotton-fitted-vest-with-grey-logo-black'
  },
  {
    plain: 'cotton-fitted-vest-light-grey-marl',
    grey: 'cotton-fitted-vest-with-grey-logo-light-grey-marl'
  },
  {
    plain: 'cotton-fitted-vest-white',
    grey: 'cotton-fitted-vest-with-grey-logo-white'
  },

  {
    plain: 'cotton-vintage-lounge-off-the-shoulder-sweatshirt-light-grey-marl',
    updated: 'cotton-vintage-lounge-off-the-shoulder-sweatshirt-light-grey-marl-new-branding'
  },
  {
    plain: 'cotton-vintage-lounge-off-the-shoulder-sweatshirt-washed-black',
    updated: 'cotton-vintage-lounge-off-the-shoulder-sweatshirt-washed-black-new-branding'
  },

  {
    plain: 'cotton-vintage-lounge-v-neck-sweatshirt-light-grey-marl',
    updated: 'cotton-vintage-lounge-v-neck-sweatshirt-light-grey-marl-new-branding'
  },
  {
    plain: 'cotton-vintage-lounge-v-neck-sweatshirt-washed-black',
    updated: 'cotton-vintage-lounge-v-neck-sweatshirt-washed-black-new-branding'
  },

  {
    plain: 'cotton-vintage-lounge-wide-leg-joggers-light-grey-marl',
    updated: 'cotton-vintage-lounge-wide-leg-sweatpants-light-grey-marl-new-branding'
  },
  {
    plain: 'cotton-vintage-lounge-wide-leg-joggers-washed-black',
    updated: 'cotton-vintage-lounge-wide-leg-sweatpants-washed-black-new-branding'
  },

  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-black',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-black',
    updated: 'easylift-cross-back-sports-bra-new-branding-black'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-blackberry-purple',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-blackberry-purple'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-coal',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-coal'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-plum-brown',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-plum-brown',
    updated: 'easylift-cross-back-sports-bra-new-branding-plum-brown'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-racing-green',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-racing-green'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-rosewood',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-rosewood',
    updated: 'easylift-cross-back-sports-bra-new-branding-rosewood'
  },
  {
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-ruby-red',
    updated: 'easylift-cross-back-sports-bra-new-branding-ruby-red'
  },
  {
    white: 'easylift-cross-back-sports-bra-with-white-logo-true-blue',
    grey: 'easylift-cross-back-sports-bra-with-grey-logo-true-blue',
    updated: 'easylift-cross-back-sports-bra-new-branding-true-blue'
  },

  {
    white: 'easylift-halter-bralette-with-white-logo-alpine-green',
    grey: 'easylift-halter-bralette-with-grey-logo-alpine-green'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-black',
    grey: 'easylift-halter-bralette-with-grey-logo-black',
    updated: 'easylift-halter-bralette-new-branding-black'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-blackberry-purple',
    grey: 'easylift-halter-bralette-with-grey-logo-blackberry-purple'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-chalk-pink',
    grey: 'easylift-halter-bralette-with-grey-logo-chalk-pink'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-coal',
    grey: 'easylift-halter-bralette-with-grey-logo-coal'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-dark-umber-brown',
    updated: 'easylift-halter-bralette-new-branding-dark-umber-brown'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-plum-brown',
    grey: 'easylift-halter-bralette-with-grey-logo-plum-brown',
    updated: 'easylift-halter-bralette-new-branding-plum-brown'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-racing-green',
    grey: 'easylift-halter-bralette-with-grey-logo-racing-green'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-rosewood',
    grey: 'easylift-halter-bralette-with-grey-logo-rosewood',
    updated: 'easylift-halter-bralette-new-branding-rosewood'
  },
  {
    grey: 'easylift-halter-bralette-with-grey-logo-ruby-red',
    updated: 'easylift-halter-bralette-new-branding-ruby-red'
  },
  {
    white: 'easylift-halter-bralette-with-white-logo-true-blue',
    grey: 'easylift-halter-bralette-with-grey-logo-true-blue',
    updated: 'easylift-halter-bralette-new-branding-true-blue'
  },
  {
    plain: 'easylift-halter-bralette-white',
    updated: 'easylift-halter-bralette-new-branding-white'
  },

  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-70-cocoa',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-70-cocoa'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-black',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-black',
    updated: 'easylift-high-neck-sports-bra-new-branding-black'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-blackberry-purple',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-blackberry-purple'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-chalk-pink',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-chalk-pink'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-citrus-green',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-citrus-green'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-coal',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-coal'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-dark-umber-brown',
    updated: 'easylift-high-neck-sports-bra-new-branding-dark-umber-brown'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-plum-brown',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-plum-brown'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-racing-green',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-racing-green'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-rosewood',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-rosewood',
    updated: 'easylift-high-neck-sports-bra-new-branding-rosewood'
  },
  {
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-ruby-red',
    updated: 'easylift-high-neck-sports-bra-new-branding-ruby-red'
  },
  {
    white: 'easylift-high-neck-sports-bra-with-white-logo-true-blue',
    grey: 'easylift-high-neck-sports-bra-with-grey-logo-true-blue',
    updated: 'easylift-high-neck-sports-bra-new-branding-true-blue'
  },
  {
    plain: 'easylift-high-neck-sports-bra-white',
    updated: 'easylift-high-neck-sports-bra-new-branding-white'
  },

  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-alpine-green',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-alpine-green'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-black',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-black',
    updated: 'easylift-ultra-minimal-bralette-new-branding-black'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-blackberry-purple',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-blackberry-purple'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-coal',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-coal'
  },
  {
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-plum-brown',
    updated: 'easylift-ultra-minimal-bralette-new-branding-plum-brown'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-racing-green',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-racing-green'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-rosewood',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-rosewood',
    updated: 'easylift-ultra-minimal-bralette-new-branding-rosewood'
  },
  {
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-ruby-red',
    updated: 'easylift-ultra-minimal-bralette-new-branding-ruby-red'
  },
  {
    white: 'easylift-ultra-minimal-bralette-with-white-logo-true-blue',
    grey: 'easylift-ultra-minimal-bralette-with-grey-logo-true-blue',
    updated: 'easylift-ultra-minimal-bralette-new-branding-true-blue'
  },
  {
    plain: 'easylift-ultra-minimal-bralette-white',
    updated: 'easylift-ultra-minimal-bralette-new-branding-white'
  },

  {
    white: 'easylift-zip-high-neck-sports-bra-with-white-logo-true-blue',
    grey: 'easylift-zip-high-neck-sports-bra-with-grey-logo-true-blue'
  },

  {
    white: 'effortlesslift-seamless-halter-neck-sports-bra-with-white-logo-black',
    grey: 'effortlesslift-seamless-halter-neck-sports-bra-with-grey-logo-black',
    updated: 'effortlesslift-seamless-halter-neck-sports-bra-new-branding-black'
  },
  {
    white: 'effortlesslift-seamless-halter-neck-sports-bra-with-white-logo-coal',
    grey: 'effortlesslift-seamless-halter-neck-sports-bra-with-grey-logo-coal'
  },
  {
    white: 'effortlesslift-seamless-halter-neck-sports-bra-with-white-logo-true-blue',
    grey: 'effortlesslift-seamless-halter-neck-sports-bra-with-grey-logo-true-blue',
    updated: 'effortlesslift-seamless-halter-neck-sports-bra-new-branding-true-blue'
  },
  {
    plain: 'effortlesslift-seamless-halter-neck-sports-bra-white',
    updated: 'effortlesslift-seamless-halter-neck-sports-bra-new-branding-white'
  },

  {
    plain: 'effortlesslift-seamless-high-neck-bralette-printed-logo-evergreen',
    white: 'effortlesslift-seamless-high-neck-bralette-with-white-logo-evergreen'
  },
  {
    plain: 'effortlesslift-seamless-high-neck-bralette-printed-logo-sage',
    white: 'effortlesslift-seamless-high-neck-bralette-with-white-logo-sage'
  },

  {
    white: 'effortlesslift-seamless-leggings-with-white-logo-dark-khaki',
    grey: 'effortlesslift-seamless-leggings-with-grey-logo-dark-khaki'
  },
  {
    plain: 'effortlesslift-seamless-leggings-fuchsia',
    white: 'effortlesslift-seamless-leggings-with-white-logo-fuchsia'
  },
  {
    white: 'effortlesslift-seamless-leggings-with-white-logo-true-blue',
    grey: 'effortlesslift-seamless-leggings-with-grey-logo-true-blue'
  },

  {
    grey: 'effortlesslift-seamless-mid-rise-leggings-with-grey-logo-black',
    updated: 'effortlesslift-seamless-mid-rise-leggings-new-branding-black'
  },
  {
    grey: 'effortlesslift-seamless-mid-rise-leggings-with-grey-logo-true-blue',
    updated: 'effortlesslift-seamless-mid-rise-leggings-new-branding-true-blue'
  },

  {
    grey: 'effortlesslift-seamless-mid-rise-shorts-with-grey-logo-black',
    updated: 'effortlesslift-seamless-mid-rise-shorts-new-branding-black'
  },
  {
    grey: 'effortlesslift-seamless-mid-rise-shorts-with-grey-logo-true-blue',
    updated: 'effortlesslift-seamless-mid-rise-shorts-new-branding-true-blue'
  },

  {
    white: 'effortlesslift-seamless-shorts-with-white-logo-chalk-pink',
    grey: 'effortlesslift-seamless-shorts-with-grey-logo-chalk-pink'
  },
  {
    white: 'effortlesslift-seamless-shorts-with-white-logo-citrus-green',
    grey: 'effortlesslift-seamless-shorts-with-grey-logo-citrus-green'
  },
  {
    white: 'effortlesslift-seamless-shorts-with-white-logo-dark-khaki',
    grey: 'effortlesslift-seamless-shorts-with-grey-logo-dark-khaki'
  },
  {
    plain: 'effortlesslift-seamless-shorts-fuchsia',
    white: 'effortlesslift-seamless-shorts-with-white-logo-fuchsia'
  },
  {
    white: 'effortlesslift-seamless-shorts-with-white-logo-true-blue',
    grey: 'effortlesslift-seamless-shorts-with-grey-logo-true-blue'
  },

  {
    white: 'enhancelift-seamless-crop-jacket-with-white-logo-black',
    grey: 'enhancelift-seamless-crop-jacket-with-grey-logo-black'
  },
  {
    white: 'enhancelift-seamless-crop-jacket-with-white-logo-coal',
    grey: 'enhancelift-seamless-crop-jacket-with-grey-logo-coal'
  },
  {
    white: 'enhancelift-seamless-crop-jacket-with-white-logo-true-blue',
    grey: 'enhancelift-seamless-crop-jacket-with-grey-logo-true-blue'
  },

  {
    white: 'enhancelift-seamless-leggings-with-white-logo-black',
    grey: 'enhancelift-seamless-leggings-with-grey-logo-black'
  },
  {
    white: 'enhancelift-seamless-leggings-with-white-logo-burnt-maroon',
    grey: 'enhancelift-seamless-leggings-with-grey-logo-burnt-maroon'
  },
  {
    white: 'enhancelift-seamless-leggings-with-white-logo-coal',
    grey: 'enhancelift-seamless-leggings-with-grey-logo-coal'
  },
  {
    white: 'enhancelift-seamless-leggings-with-white-logo-plum-brown',
    grey: 'enhancelift-seamless-leggings-with-grey-logo-plum-brown'
  },
  {
    white: 'enhancelift-seamless-leggings-with-white-logo-true-blue',
    grey: 'enhancelift-seamless-leggings-with-grey-logo-true-blue'
  },

  {
    white: 'enhancelift-seamless-minimal-halter-neck-bralette-with-white-logo-black',
    grey: 'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-black',
    updated: 'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-black'
  },
  {
    white: 'enhancelift-seamless-minimal-halter-neck-bralette-with-white-logo-burnt-maroon',
    grey: 'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-burnt-maroon',
    updated: 'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-burnt-maroon'
  },
  {
    white: 'enhancelift-seamless-minimal-halter-neck-bralette-with-white-logo-coal',
    grey: 'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-coal'
  },
  {
    white: 'enhancelift-seamless-minimal-halter-neck-bralette-with-white-logo-plum-brown',
    grey: 'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-plum-brown',
    updated: 'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-plum-brown'
  },
  {
    white: 'enhancelift-seamless-minimal-halter-neck-bralette-with-white-logo-true-blue',
    grey: 'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-true-blue',
    updated: 'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-true-blue'
  },
  {
    plain: 'enhancelift-seamless-minimal-halter-neck-bralette-white',
    updated: 'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-white'
  },

  {
    white: 'enhancelift-seamless-shorts-with-white-logo-black',
    grey: 'enhancelift-seamless-shorts-with-grey-logo-black'
  },
  {
    white: 'enhancelift-seamless-shorts-with-white-logo-burnt-maroon',
    grey: 'enhancelift-seamless-shorts-with-grey-logo-burnt-maroon'
  },
  {
    white: 'enhancelift-seamless-shorts-with-white-logo-coal',
    grey: 'enhancelift-seamless-shorts-with-grey-logo-coal'
  },
  {
    white: 'enhancelift-seamless-shorts-with-white-logo-plum-brown',
    grey: 'enhancelift-seamless-shorts-with-grey-logo-plum-brown'
  },
  {
    white: 'enhancelift-seamless-shorts-with-white-logo-true-blue',
    grey: 'enhancelift-seamless-shorts-with-grey-logo-true-blue'
  },

  {
    grey: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-new-branding-black'
  },
  {
    grey: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-shelf-with-grey-logo-burnt-maroon',
    updated: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-new-branding-burnt-maroon'
  },
  {
    grey: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-shelf-with-grey-logo-plum-brown',
    updated: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-new-branding-plum-brown'
  },
  {
    grey: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-new-branding-true-blue'
  },
  {
    grey: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-shelf-with-grey-logo-white',
    updated: 'enhancelift-seamless-strappy-racer-vest-with-built-in-bra-new-branding-white'
  },

  {
    white: 'enhancelift-seamless-strappy-sports-bra-with-white-logo-black',
    grey: 'enhancelift-seamless-strappy-sports-bra-with-grey-logo-black',
    updated: 'enhancelift-seamless-strappy-sports-bra-new-branding-black'
  },
  {
    white: 'enhancelift-seamless-strappy-sports-bra-with-white-logo-burnt-maroon',
    grey: 'enhancelift-seamless-strappy-sports-bra-with-grey-logo-burnt-maroon',
    updated: 'enhancelift-seamless-strappy-sports-bra-new-branding-burnt-maroon'
  },
  {
    white: 'enhancelift-seamless-strappy-sports-bra-with-white-logo-coal',
    grey: 'enhancelift-seamless-strappy-sports-bra-with-grey-logo-coal'
  },
  {
    white: 'enhancelift-seamless-strappy-sports-bra-with-white-logo-plum-brown',
    grey: 'enhancelift-seamless-strappy-sports-bra-with-grey-logo-plum-brown',
    updated: 'enhancelift-seamless-strappy-sports-bra-new-branding-plum-brown'
  },
  {
    white: 'enhancelift-seamless-strappy-sports-bra-with-white-logo-true-blue',
    grey: 'enhancelift-seamless-strappy-sports-bra-with-grey-logo-true-blue',
    updated: 'enhancelift-seamless-strappy-sports-bra-new-branding-true-blue'
  },
  {
    plain: 'enhancelift-seamless-strappy-sports-bra-white',
    updated: 'enhancelift-seamless-strappy-sports-bra-new-branding-white'
  },

  {
    plain: 'foundations-all-season-cropped-zip-through-hoodie-black',
    updated: 'foundations-all-season-cropped-zip-through-hoodie-new-branding-black'
  },
  {
    plain: 'foundations-all-season-cropped-zip-through-hoodie-grey-marl',
    updated: 'foundations-all-season-cropped-zip-through-hoodie-new-branding-grey-marl'
  },
  {
    plain: 'foundations-all-season-cropped-zip-through-hoodie-oat-marl',
    updated: 'foundations-all-season-cropped-zip-through-hoodie-new-branding-oat-marl'
  },

  {
    plain: 'foundations-hoodie-plum-brown',
    grey: 'foundations-hoodie-with-grey-logo-plum-brown'
  },

  {
    plain: 'foundations-jogger-plum-brown',
    grey: 'foundations-joggers-with-grey-logo-plum-brown'
  },

  {
    plain: 'foundations-zip-through-hoodie-plum-brown',
    grey: 'foundations-zip-through-hoodie-with-grey-logo-plum-brown'
  },

  {
    plain: 'mellow-rib-long-sleeve-cardigan-black',
    embroidered: 'mellow-rib-long-sleeve-cardigan-with-embroidered-logo-black'
  },
  {
    plain: 'mellow-rib-long-sleeve-cardigan-white',
    embroidered: 'mellow-rib-long-sleeve-cardigan-with-embroidered-logo-white'
  },

  {
    plain: 'mellow-rib-mid-long-sleeve-cardigan-black',
    embroidered: 'mellow-rib-mid-long-sleeve-cardigan-with-embroidered-logo-black'
  },
  {
    plain: 'mellow-rib-mid-long-sleeve-cardigan-white',
    embroidered: 'mellow-rib-mid-long-sleeve-cardigan-with-embroidered-logo-white'
  },

  {
    plain: 'mid-crew-socks-3-pack-grey-white-black',
    updated: 'mid-crew-socks-3-pack-grey-white-black-new-branding'
  },
  {
    plain: 'mid-crew-socks-3-pack-white',
    updated: 'mid-crew-socks-3-pack-white-new-branding'
  },

  {
    plain: 'oner-seamless-fitted-long-sleeve-top-black',
    updated: 'oner-seamless-fitted-long-sleeve-top-new-branding-black'
  },

  {
    plain: 'oner-seamless-fitted-vest-black',
    updated: 'oner-seamless-fitted-tank-top-new-branding-black'
  },
  {
    plain: 'oner-seamless-fitted-vest-white',
    updated: 'oner-seamless-fitted-tank-top-new-branding-white'
  },

  {
    plain: 'oner-seamless-fitted-top-black',
    updated: 'oner-seamless-fitted-top-new-branding-black'
  },
  {
    plain: 'oner-seamless-fitted-top-white',
    updated: 'oner-seamless-fitted-top-new-branding-white'
  },

  {
    plain: 'quilted-tote-bag-black',
    updated: 'quilted-tote-bag-new-branding-black'
  },

  {
    white: 'softmotion-bralette-with-white-logo-alpine-green',
    grey: 'softmotion-bralette-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-bralette-with-white-logo-ash-grey',
    grey: 'softmotion-bralette-with-grey-logo-ash-grey'
  },
  {
    white: 'softmotion-bralette-with-white-logo-black',
    grey: 'softmotion-bralette-with-grey-logo-black',
    updated: 'softmotion-bralette-new-branding-black'
  },
  {
    white: 'softmotion-bralette-with-white-logo-coal',
    grey: 'softmotion-bralette-with-grey-logo-coal'
  },
  {
    white: 'softmotion-bralette-with-white-logo-dark-umber-brown',
    grey: 'softmotion-bralette-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-bralette-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-bralette-with-grey-logo-emerald-noir',
    updated: 'softmotion-bralette-emerald-noir-new-branding-2-0'
  },
  {
    grey: 'softmotion-bralette-with-grey-logo-oatmeal',
    updated: 'softmotion-bralette-oatmeal-new-branding-2-0'
  },
  {
    white: 'softmotion-bralette-with-white-logo-true-blue',
    grey: 'softmotion-bralette-with-grey-logo-true-blue',
    updated: 'softmotion-bralette-new-branding-true-blue'
  },
  {
    plain: 'softmotion-bralette-white',
    updated: 'softmotion-bralette-new-branding-white'
  },

  {
    grey: 'softmotion-double-layer-high-waisted-shorts-6-with-grey-logo-marshmallow-white',
    updated: 'softmotion-double-layer-high-waisted-shorts-6-marshmallow-white-new-branding'
  },

  {
    grey: 'softmotion-double-layer-mid-rise-micro-shorts-4-with-grey-logo-marshmallow-white',
    updated: 'softmotion-double-layer-mid-rise-micro-shorts-4-marshmallow-white-new-branding'
  },

  {
    white: 'softmotion-flared-bottoms-with-white-logo-alpine-green',
    grey: 'softmotion-flared-bottoms-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-ash-grey',
    grey: 'softmotion-flared-bottoms-with-grey-logo-ash-grey'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-black',
    grey: 'softmotion-flared-bottoms-with-grey-logo-black',
    updated: 'softmotion-flared-pants-new-branding-black'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-coal',
    grey: 'softmotion-flared-bottoms-with-grey-logo-coal'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-dark-khaki',
    grey: 'softmotion-flared-bottoms-with-grey-logo-dark-khaki'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-dark-umber-brown',
    grey: 'softmotion-flared-bottoms-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-flared-pants-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-flared-bottoms-with-grey-logo-emerald-noir',
    updated: 'softmotion-flared-pants-emerald-noir-new-branding'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-moss-brown',
    grey: 'softmotion-flared-bottoms-with-grey-logo-moss-brown'
  },
  {
    grey: 'softmotion-flared-bottoms-with-grey-logo-oatmeal',
    updated: 'softmotion-flared-pants-oatmeal-new-branding'
  },
  {
    grey: 'softmotion-flared-bottoms-with-grey-logo-plum-brown',
    updated: 'softmotion-flared-pants-new-branding-plum-brown'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-true-blue',
    grey: 'softmotion-flared-bottoms-with-grey-logo-true-blue',
    updated: 'softmotion-flared-pants-new-branding-true-blue'
  },
  {
    white: 'softmotion-flared-bottoms-with-white-logo-warm-sand',
    updated: 'softmotion-flared-pants-new-branding-warm-sand'
  },

  {
    white: 'softmotion-headband-with-white-logo-black',
    grey: 'softmotion-headband-with-grey-logo-black'
  },
  {
    white: 'softmotion-headband-with-white-logo-dark-umber-brown',
    grey: 'softmotion-headband-with-grey-logo-dark-umber-brown'
  },

  {
    white: 'softmotion-high-neck-sports-bra-with-white-logo-alpine-green',
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-high-neck-sports-bra-with-white-logo-black',
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-black',
    updated: 'softmotion-high-neck-sports-bra-new-branding-black'
  },
  {
    white: 'softmotion-high-neck-sports-bra-with-white-logo-coal',
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-coal'
  },
  {
    white: 'softmotion-high-neck-sports-bra-with-white-logo-dark-umber-brown',
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-high-neck-sports-bra-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-plum-brown',
    updated: 'softmotion-high-neck-sports-bra-new-branding-plum-brown'
  },
  {
    white: 'softmotion-high-neck-sports-bra-with-white-logo-true-blue',
    grey: 'softmotion-high-neck-sports-bra-with-grey-logo-true-blue',
    updated: 'softmotion-high-neck-sports-bra-new-branding-true-blue'
  },
  {
    plain: 'softmotion-high-neck-sports-bra-white',
    updated: 'softmotion-high-neck-sports-bra-new-branding-white'
  },

  {
    white: 'softmotion-high-waisted-capri-leggings-with-white-logo-black',
    grey: 'softmotion-high-waisted-capri-leggings-with-grey-logo-black',
    updated: 'softmotion-high-waisted-capri-leggings-new-branding-black'
  },

  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-alpine-green',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-black',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-black',
    updated: 'softmotion-high-waisted-leggings-new-branding-black'
  },
  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-coal',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-coal'
  },
  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-dark-umber-brown',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-high-waisted-leggings-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-emerald-noir',
    updated: 'softmotion-high-waisted-leggings-emerald-noir-new-branding'
  },
  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-ruby-red',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-ruby-red'
  },
  {
    white: 'softmotion-high-waisted-leggings-with-white-logo-true-blue',
    grey: 'softmotion-high-waisted-leggings-with-grey-logo-true-blue',
    updated: 'softmotion-high-waisted-leggings-new-branding-true-blue'
  },

  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-alpine-green',
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-black',
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-black',
    updated: 'softmotion-high-waisted-shorts-6-new-branding-black'
  },
  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-coal',
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-coal'
  },
  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-dark-umber-brown',
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-high-waisted-shorts-6-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-emerald-noir',
    updated: 'softmotion-high-waisted-shorts-6-emerald-noir-new-branding'
  },
  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-rose-pink',
    updated: 'softmotion-high-waisted-shorts-6-new-branding-rose-pink'
  },
  {
    white: 'softmotion-high-waisted-shorts-6-with-white-logo-true-blue',
    grey: 'softmotion-high-waisted-shorts-6-with-grey-logo-true-blue',
    updated: 'softmotion-high-waisted-shorts-6-new-branding-true-blue'
  },

  {
    white: 'softmotion-jacket-with-white-logo-alpine-green',
    grey: 'softmotion-jacket-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-jacket-with-white-logo-ash-grey',
    grey: 'softmotion-jacket-with-grey-logo-ash-grey'
  },
  {
    white: 'softmotion-jacket-with-white-logo-black',
    grey: 'softmotion-jacket-with-grey-logo-black',
    updated: 'softmotion-jacket-new-branding-black'
  },
  {
    white: 'softmotion-jacket-with-white-logo-chalk-pink',
    grey: 'softmotion-jacket-with-grey-logo-chalk-pink'
  },
  {
    white: 'softmotion-jacket-with-white-logo-coal',
    grey: 'softmotion-jacket-with-grey-logo-coal'
  },
  {
    white: 'softmotion-jacket-with-white-logo-dark-umber-brown',
    grey: 'softmotion-jacket-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-jacket-new-branding-dark-umber-brown'
  },
  {
    white: 'softmotion-jacket-with-white-logo-moss-brown',
    grey: 'softmotion-jacket-with-grey-logo-moss-brown'
  },
  {
    grey: 'softmotion-jacket-with-grey-logo-plum-brown',
    updated: 'softmotion-jacket-new-branding-plum-brown'
  },
  {
    white: 'softmotion-jacket-with-white-logo-ruby-red',
    grey: 'softmotion-jacket-with-grey-logo-ruby-red'
  },
  {
    white: 'softmotion-jacket-with-white-logo-true-blue',
    grey: 'softmotion-jacket-with-grey-logo-true-blue',
    updated: 'softmotion-jacket-new-branding-true-blue'
  },

  {
    white: 'softmotion-long-sleeve-mid-top-with-white-logo-black',
    grey: 'softmotion-long-sleeve-mid-top-with-grey-logo-black',
    updated: 'softmotion-long-sleeve-mid-top-new-branding-black'
  },

  {
    white: 'softmotion-long-sleeve-top-with-white-logo-black',
    grey: 'softmotion-long-sleeve-top-with-grey-logo-black',
    updated: 'softmotion-long-sleeve-top-new-branding-black'
  },

  {
    grey: 'softmotion-mid-rise-micro-shorts-4-with-grey-logo-black',
    updated: 'softmotion-mid-rise-micro-shorts-4-new-branding-black'
  },
  {
    grey: 'softmotion-mid-rise-micro-shorts-4-with-grey-logo-emerald-noir',
    updated: 'softmotion-mid-rise-micro-shorts-4-emerald-noir-new-branding'
  },
  {
    grey: 'softmotion-mid-rise-micro-shorts-4-with-grey-logo-true-blue',
    updated: 'softmotion-mid-rise-micro-shorts-4-new-branding-true-blue'
  },

  {
    white: 'softmotion-minimal-halter-neck-bralette-with-white-logo-alpine-green',
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-minimal-halter-neck-bralette-with-white-logo-black',
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-black',
    updated: 'softmotion-minimal-halter-neck-bralette-new-branding-black'
  },
  {
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-minimal-halter-neck-bralette-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-emerald-noir',
    updated: 'softmotion-minimal-halter-neck-bralette-emerald-noir-new-branding'
  },
  {
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-marshmallow-white',
    updated: 'softmotion-minimal-halter-neck-bralette-marshmallow-white-new-branding'
  },
  {
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-oatmeal',
    updated: 'softmotion-minimal-halter-neck-bralette-oatmeal-new-branding'
  },
  {
    white: 'softmotion-minimal-halter-neck-bralette-with-white-logo-rose-pink',
    updated: 'softmotion-minimal-halter-neck-bralette-new-branding-rose-pink'
  },
  {
    white: 'softmotion-minimal-halter-neck-bralette-with-white-logo-ruby-red',
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-ruby-red'
  },
  {
    grey: 'softmotion-minimal-halter-neck-bralette-with-grey-logo-true-blue',
    updated: 'softmotion-minimal-halter-neck-bralette-new-branding-true-blue'
  },

  {
    white: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-white-logo-black',
    grey: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-racer-back-mid-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    white: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-white-logo-coal',
    grey: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-grey-logo-coal'
  },
  {
    white: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-white-logo-dark-khaki',
    grey: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-grey-logo-dark-khaki'
  },
  {
    white: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-white-logo-true-blue',
    grey: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-racer-back-mid-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    plain: 'softmotion-racer-back-mid-vest-with-built-in-bra-shelf-white',
    updated: 'softmotion-racer-back-mid-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    white: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-white-logo-black',
    grey: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-racer-back-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    white: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-white-logo-dark-khaki',
    grey: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-grey-logo-dark-khaki'
  },
  {
    white: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-white-logo-true-blue',
    grey: 'softmotion-racer-back-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-racer-back-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    plain: 'softmotion-racer-back-vest-with-built-in-bra-shelf-white',
    updated: 'softmotion-racer-back-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-alpine-green',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-ash-grey',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-ash-grey'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-black',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-black',
    updated: 'softmotion-scoop-back-bralette-new-branding-black'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-chalk-pink',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-chalk-pink'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-coal',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-coal'
  },
  {
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-scoop-back-bralette-new-branding-dark-umber-brown'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-moss-brown',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-moss-brown'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-true-blue',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-true-blue',
    updated: 'softmotion-scoop-back-bralette-new-branding-true-blue'
  },
  {
    white: 'softmotion-scoop-back-bralette-with-white-logo-velvet-mocha',
    grey: 'softmotion-scoop-back-bralette-with-grey-logo-velvet-mocha'
  },
  {
    plain: 'softmotion-scoop-back-bralette-white',
    updated: 'softmotion-scoop-back-bralette-new-branding-white'
  },

  {
    white: 'softmotion-scoop-back-flared-all-in-one-long-with-white-logo-black',
    grey: 'softmotion-scoop-back-flared-all-in-one-long-with-grey-logo-black'
  },

  {
    white: 'softmotion-scoop-neck-vest-with-white-logo-alpine-green',
    grey: 'softmotion-scoop-neck-vest-with-grey-logo-alpine-green'
  },

  {
    white: 'softmotion-sports-bra-with-white-logo-black',
    updated: 'softmotion-sports-bra-new-branding-black'
  },
  {
    white: 'softmotion-sports-bra-with-white-logo-true-blue',
    grey: 'softmotion-sports-bra-with-grey-logo-true-blue',
    updated: 'softmotion-sports-bra-new-branding-true-blue'
  },
  {
    plain: 'softmotion-sports-bra-white',
    updated: 'softmotion-sports-bra-new-branding-white'
  },

  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-alpine-green',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-alpine-green'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-ash-grey',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-ash-grey'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-black',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-black',
    updated: 'softmotion-straight-leg-pants-new-branding-black'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-coal',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-coal'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-dark-khaki',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-dark-khaki'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-dark-umber-brown',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-straight-leg-pants-new-branding-dark-umber-brown'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-dusty-purple',
    updated: 'softmotion-straight-leg-pants-new-branding-dusty-purple'
  },
  {
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-emerald-noir',
    updated: 'softmotion-straight-leg-pants-emerald-noir-new-branding'
  },
  {
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-oatmeal',
    updated: 'softmotion-straight-leg-pants-oatmeal-new-branding'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-rose-pink',
    updated: 'softmotion-straight-leg-pants-new-branding-rose-pink'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-ruby-red',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-ruby-red'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-true-blue',
    grey: 'softmotion-straight-leg-bottoms-with-grey-logo-true-blue',
    updated: 'softmotion-straight-leg-pants-new-branding-true-blue'
  },
  {
    white: 'softmotion-straight-leg-bottoms-with-white-logo-warm-sand',
    updated: 'softmotion-straight-leg-pants-new-branding-warm-sand'
  },

  {
    grey: 'softmotion-strappy-halter-neck-mid-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-strappy-halter-neck-mid-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    grey: 'softmotion-strappy-halter-neck-mid-vest-with-built-in-bra-shelf-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-strappy-halter-neck-mid-tank-top-with-built-in-bra-shelf-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-strappy-halter-neck-mid-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-strappy-halter-neck-mid-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    white: 'softmotion-strappy-halter-neck-mid-vest-with-built-in-bra-shelf-with-white-logo-warm-sand',
    updated: 'softmotion-strappy-halter-neck-mid-tank-top-with-built-in-bra-shelf-new-branding-warm-sand'
  },
  {
    grey: 'softmotion-strappy-halter-neck-mid-vest-with-built-in-bra-shelf-with-grey-logo-white',
    updated: 'softmotion-strappy-halter-neck-mid-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    grey: 'softmotion-strappy-halter-neck-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-strappy-halter-neck-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    grey: 'softmotion-strappy-halter-neck-vest-with-built-in-bra-shelf-with-grey-logo-dark-umber-brown',
    updated: 'softmotion-strappy-halter-neck-tank-top-with-built-in-bra-shelf-new-branding-dark-umber-brown'
  },
  {
    grey: 'softmotion-strappy-halter-neck-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-strappy-halter-neck-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    white: 'softmotion-strappy-halter-neck-vest-with-built-in-bra-shelf-with-white-logo-warm-sand',
    updated: 'softmotion-strappy-halter-neck-tank-top-with-built-in-bra-shelf-new-branding-warm-sand'
  },
  {
    grey: 'softmotion-strappy-halter-neck-vest-with-built-in-bra-shelf-with-grey-logo-white',
    updated: 'softmotion-strappy-halter-neck-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    white: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-white-logo-black',
    grey: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-strappy-mid-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    white: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-white-logo-coal',
    grey: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-grey-logo-coal'
  },
  {
    white: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-white-logo-dark-umber-brown',
    grey: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-grey-logo-dark-umber-brown'
  },
  {
    white: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-white-logo-ruby-red',
    grey: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-grey-logo-ruby-red'
  },
  {
    white: 'softmotion-strappy-mid-vest-with-white-logo-true-blue',
    grey: 'softmotion-strappy-mid-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-strappy-mid-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    plain: 'softmotion-strappy-mid-vest-white',
    updated: 'softmotion-strappy-mid-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    grey: 'softmotion-strappy-sports-bra-with-grey-logo-black',
    updated: 'softmotion-strappy-sports-bra-black-new-branding'
  },
  {
    grey: 'softmotion-strappy-sports-bra-with-grey-logo-emerald-noir',
    updated: 'softmotion-strappy-sports-bra-emerald-noir-new-branding'
  },
  {
    grey: 'softmotion-strappy-sports-bra-with-grey-logo-oatmeal',
    updated: 'softmotion-strappy-sports-bra-oatmeal-new-branding'
  },

  {
    white: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-white-logo-black',
    grey: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-grey-logo-black',
    updated: 'softmotion-strappy-tank-top-with-built-in-bra-shelf-new-branding-black'
  },
  {
    white: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-white-logo-coal',
    grey: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-grey-logo-coal'
  },
  {
    white: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-white-logo-dark-umber-brown',
    grey: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-grey-logo-dark-umber-brown'
  },
  {
    white: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-white-logo-ruby-red',
    grey: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-grey-logo-ruby-red'
  },
  {
    white: 'softmotion-strappy-vest-with-white-logo-true-blue',
    grey: 'softmotion-strappy-vest-with-built-in-bra-shelf-with-grey-logo-true-blue',
    updated: 'softmotion-strappy-tank-top-with-built-in-bra-shelf-new-branding-true-blue'
  },
  {
    plain: 'softmotion-strappy-vest-white',
    updated: 'softmotion-strappy-tank-top-with-built-in-bra-shelf-new-branding-white'
  },

  {
    reflective: 'unifiedmove-cross-back-sports-bra-with-reflective-logo-black',
    updated: 'unifiedmove-cross-back-sports-bra-new-branding-black'
  },
  {
    reflective: 'unifiedmove-cross-back-sports-bra-with-reflective-logo-white',
    updated: 'unifiedmove-cross-back-sports-bra-new-branding-white'
  },

  {
    plain: 'unifiedmove-double-layer-shorts-black',
    white: 'unifiedmove-double-layer-shorts-white-logo-5-black',
    reflective: 'unifiedmove-double-layer-shorts-5-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-double-layer-shorts-5-coal',
    reflective: 'unifiedmove-double-layer-shorts-5-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-double-layer-shorts-muscle-mommy-red',
    reflective: 'unifiedmove-double-layer-shorts-5-with-reflective-logo-muscle-mommy-red'
  },
  {
    plain: 'unifiedmove-double-layer-shorts-5-powdered-orange',
    reflective: 'unifiedmove-double-layer-shorts-5-with-reflective-logo-powdered-orange'
  },
  {
    plain: 'unifiedmove-double-layer-shorts-racing-green',
    reflective: 'unifiedmove-double-layer-shorts-5-with-reflective-logo-racing-green'
  },

  {
    plain: 'unifiedmove-high-waisted-leggings-black',
    white: 'unifiedmove-high-waisted-leggings-white-logo-black',
    reflective: 'unifiedmove-high-waisted-leggings-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-high-waisted-leggings-blackberry-purple',
    white: 'unifiedmove-high-waisted-leggings-white-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-high-waisted-leggings-coal',
    white: 'unifiedmove-high-waisted-leggings-white-logo-coal',
    reflective: 'unifiedmove-high-waisted-leggings-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-high-waisted-leggings-true-blue',
    white: 'unifiedmove-high-waisted-leggings-white-logo-true-blue',
    reflective: 'unifiedmove-high-waisted-leggings-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-high-waisted-pocket-leggings-black',
    white: 'unifiedmove-high-waisted-pocket-leggings-white-logo-black',
    reflective: 'unifiedmove-high-waisted-pocket-leggings-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-high-waisted-pocket-leggings-coal',
    reflective: 'unifiedmove-high-waisted-pocket-leggings-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-high-waisted-pocket-leggings-true-blue',
    reflective: 'unifiedmove-high-waisted-pocket-leggings-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-high-waisted-pocket-shorts-6-black',
    white: 'unifiedmove-high-waisted-pocket-shorts-6-white-logo-black',
    reflective: 'unifiedmove-high-waisted-pocket-shorts-6-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-high-waisted-pocket-shorts-6-coal',
    reflective: 'unifiedmove-high-waisted-pocket-shorts-6-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-high-waisted-pocket-shorts-6-true-blue',
    reflective: 'unifiedmove-high-waisted-pocket-shorts-6-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-high-waisted-shorts-black',
    white: 'unifiedmove-high-waisted-shorts-white-logo-6-black',
    reflective: 'unifiedmove-high-waisted-shorts-6-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-high-waisted-shorts-blackberry-purple',
    white: 'unifiedmove-high-waisted-shorts-white-logo-6-blackberry-purple'
  },
  {
    plain: 'unifiedmove-high-waisted-shorts-coal',
    reflective: 'unifiedmove-high-waisted-shorts-6-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-high-waisted-shorts-true-blue',
    white: 'unifiedmove-high-waisted-shorts-white-logo-6-true-blue',
    reflective: 'unifiedmove-high-waisted-shorts-6-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-jacket-black',
    reflective: 'unifiedmove-jacket-with-reflective-logo-black',
    updated: 'unifiedmove-jacket-new-branding-black'
  },
  {
    plain: 'unifiedmove-jacket-blackberry-purple',
    white: 'unifiedmove-jacket-white-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-jacket-coal',
    reflective: 'unifiedmove-jacket-with-reflective-logo-coal',
    updated: 'unifiedmove-jacket-new-branding-coal'
  },
  {
    plain: 'unifiedmove-jacket-glaucous-blue',
    reflective: 'unifiedmove-jacket-with-reflective-logo-glaucous-blue',
    updated: 'unifiedmove-jacket-new-branding-glaucous-blue'
  },
  {
    reflective: 'unifiedmove-jacket-with-reflective-logo-muscle-mommy-red',
    updated: 'unifiedmove-jacket-new-branding-muscle-mommy-red'
  },
  {
    plain: 'unifiedmove-jacket-racing-green',
    white: 'unifiedmove-jacket-white-logo-racing-green'
  },
  {
    plain: 'unifiedmove-jacket-true-blue',
    updated: 'unifiedmove-jacket-new-branding-true-blue'
  },
  {
    plain: 'unifiedmove-jacket-white',
    updated: 'unifiedmove-jacket-new-branding-white'
  },

  {
    plain: 'unifiedmove-micro-bralette-70-cocoa',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-70-cocoa'
  },
  {
    white: 'unifiedmove-micro-bralette-white-logo-black',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-black',
    updated: 'unifiedmove-micro-bralette-new-branding-black'
  },
  {
    plain: 'unifiedmove-micro-bralette-blackberry-purple',
    white: 'unifiedmove-micro-bralette-white-logo-blackberry-purple',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-micro-bralette-coal',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-coal',
    updated: 'unifiedmove-micro-bralette-new-branding-coal'
  },
  {
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-glaucous-blue',
    updated: 'unifiedmove-micro-bralette-new-branding-glaucous-blue'
  },
  {
    plain: 'unifiedmove-micro-bralette-midnight',
    white: 'unifiedmove-micro-bralette-white-logo-midnight'
  },
  {
    plain: 'unifiedmove-micro-bralette-muscle-mommy-red',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-muscle-mommy-red',
    updated: 'unifiedmove-micro-bralette-new-branding-muscle-mommy-red'
  },
  {
    plain: 'unifiedmove-micro-bralette-peony-pink',
    white: 'unifiedmove-micro-bralette-white-logo-peony-pink'
  },
  {
    plain: 'unifiedmove-micro-bralette-racing-green',
    white: 'unifiedmove-micro-bralette-white-logo-racing-green',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-racing-green'
  },
  {
    plain: 'unifiedmove-micro-bralette-rosewood',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-rosewood'
  },
  {
    plain: 'unifiedmove-micro-bralette-true-blue',
    white: 'unifiedmove-micro-bralette-white-logo-true-blue',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-true-blue'
  },
  {
    plain: 'unifiedmove-micro-bralette-white',
    reflective: 'unifiedmove-micro-bralette-with-reflective-logo-white'
  },

  {
    plain: 'unifiedmove-pocket-jacket-70-cocoa',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-70-cocoa'
  },
  {
    plain: 'unifiedmove-pocket-jacket-black',
    white: 'unifiedmove-pocket-jacket-white-logo-black',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-pocket-jacket-blackberry-purple',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-pocket-jacket-coal',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-pocket-jacket-racing-green',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-racing-green'
  },
  {
    plain: 'unifiedmove-pocket-jacket-rosewood',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-rosewood'
  },
  {
    plain: 'unifiedmove-pocket-jacket-true-blue',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-true-blue'
  },
  {
    plain: 'unifiedmove-pocket-jacket-white',
    reflective: 'unifiedmove-pocket-jacket-with-reflective-logo-white'
  },

  {
    reflective: 'unifiedmove-t-back-minimal-bralette-with-reflective-logo-black',
    updated: 'unifiedmove-t-back-minimal-bralette-new-branding-black'
  },
  {
    reflective: 'unifiedmove-t-back-minimal-bralette-with-reflective-logo-white',
    updated: 'unifiedmove-t-back-minimal-bralette-new-branding-white'
  },

  {
    plain: 'unifiedmove-twist-front-long-sleeve-crop-top-black',
    white: 'unifiedmove-twist-front-long-sleeve-crop-top-white-logo-black'
  },
  {
    plain: 'unifiedmove-twist-front-long-sleeve-crop-top-rosewood',
    white: 'unifiedmove-twist-front-long-sleeve-crop-top-white-logo-rosewood'
  },

  {
    plain: 'unifiedmove-twist-front-short-sleeve-crop-top-black',
    white: 'unifiedmove-twist-front-short-sleeve-crop-top-white-logo-black'
  },
  {
    plain: 'unifiedmove-twist-front-short-sleeve-crop-top-rosewood',
    white: 'unifiedmove-twist-front-short-sleeve-crop-top-white-logo-rosewood'
  },

  {
    plain: 'unifiedmove-twist-sports-bra-black',
    white: 'unifiedmove-twist-sports-bra-white-logo-black'
  },

  {
    reflective: 'unifiedmove-v-front-mid-rise-leggings-with-reflective-logo-black',
    updated: 'unifiedmove-v-front-mid-rise-leggings-new-branding-black'
  },

  {
    reflective: 'unifiedmove-v-front-mid-rise-shorts-6-with-reflective-logo-black',
    updated: 'unifiedmove-v-front-mid-rise-shorts-6-new-branding-black'
  },

  {
    plain: 'unifiedmove-v-neck-cross-back-vest-black',
    white: 'unifiedmove-v-neck-cross-back-vest-white-logo-black',
    reflective: 'unifiedmove-v-neck-cross-back-vest-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-v-neck-cross-back-vest-blackberry-purple',
    white: 'unifiedmove-v-neck-cross-back-vest-white-logo-blackberry-purple'
  },
  {
    white: 'unifiedmove-v-neck-cross-back-vest-white-logo-coal',
    reflective: 'unifiedmove-v-neck-cross-back-vest-with-reflective-logo-coal'
  },
  {
    white: 'unifiedmove-v-neck-cross-back-vest-white-logo-true-blue',
    reflective: 'unifiedmove-v-neck-cross-back-vest-with-reflective-logo-true-blue'
  },
  {
    plain: 'unifiedmove-v-neck-cross-back-vest-white',
    reflective: 'unifiedmove-v-neck-cross-back-vest-with-reflective-logo-white'
  },

  {
    plain: 'unifiedmove-wrap-flared-bottoms-70-cocoa',
    reflective: 'unifiedmove-wrap-flared-bottoms-with-reflective-logo-70-cocoa'
  },
  {
    plain: 'unifiedmove-wrap-flared-bottoms-black',
    white: 'unifiedmove-wrap-flared-bottoms-white-logo-black',
    reflective: 'unifiedmove-wrap-flared-bottoms-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-wrap-flared-bottoms-coal',
    white: 'unifiedmove-wrap-flared-bottoms-white-logo-coal',
    reflective: 'unifiedmove-wrap-flared-bottoms-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-wrap-flared-bottoms-rosewood',
    reflective: 'unifiedmove-wrap-flared-bottoms-with-reflective-logo-rosewood'
  },
  {
    plain: 'unifiedmove-wrap-flared-bottoms-true-blue',
    reflective: 'unifiedmove-wrap-flared-bottoms-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-wrap-leggings-70-cocoa',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-70-cocoa'
  },
  {
    plain: 'unifiedmove-wrap-leggings-black',
    white: 'unifiedmove-wrap-leggings-white-logo-black',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-black'
  },
  {
    white: 'unifiedmove-wrap-leggings-white-logo-blackberry-purple',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-wrap-leggings-coal',
    white: 'unifiedmove-wrap-leggings-white-logo-coal',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-wrap-leggings-racing-green',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-racing-green'
  },
  {
    plain: 'unifiedmove-wrap-leggings-rosewood',
    white: 'unifiedmove-wrap-leggings-white-logo-rosewood',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-rosewood'
  },
  {
    plain: 'unifiedmove-wrap-leggings-true-blue',
    white: 'unifiedmove-wrap-leggings-white-logo-true-blue',
    reflective: 'unifiedmove-wrap-leggings-with-reflective-logo-true-blue'
  },

  {
    plain: 'unifiedmove-wrap-shorts-6-70-cocoa',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-70-cocoa'
  },
  {
    plain: 'unifiedmove-wrap-shorts-black',
    white: 'unifiedmove-wrap-shorts-white-logo-black',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-black'
  },
  {
    plain: 'unifiedmove-wrap-shorts-blackberry-purple',
    white: 'unifiedmove-wrap-shorts-white-logo-6-blackberry-purple',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-blackberry-purple'
  },
  {
    plain: 'unifiedmove-wrap-shorts-6-coal',
    white: 'unifiedmove-wrap-shorts-white-logo-6-coal',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-coal'
  },
  {
    plain: 'unifiedmove-wrap-shorts-6-racing-green',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-racing-green'
  },
  {
    plain: 'unifiedmove-wrap-shorts-rosewood',
    white: 'unifiedmove-wrap-shorts-white-logo-6-rosewood',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-rosewood'
  },
  {
    plain: 'unifiedmove-wrap-shorts-true-blue',
    white: 'unifiedmove-wrap-shorts-white-logo-6-true-blue',
    reflective: 'unifiedmove-wrap-shorts-6-with-reflective-logo-true-blue'
  }
];
